import React from 'react'
import { Container, Grid, Box, Typography } from '@mui/material'
import iconLogin from './../../assets/auth/illustration-dashboard.webp'
import FormForgotPassword from '../../components/auth/FormForgotPassword';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                minHeight: '100dvh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: (theme) => theme.palette.mode === 'dark'
                    ? 'radial-gradient(circle at 30% 20%, #1e293b, #020617 60%)'
                    : 'radial-gradient(circle at 30% 20%, #FFF7D6 0%, #F8FAFC 50%, #F1F5F9 100%)',
                py: { xs: 3, md: 5 },
                px: 2,
            }}
        >
            <Container maxWidth="lg">
                <Grid
                    container
                    spacing={{ md: 6, xs: 3 }}
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={5}>
                        <Box
                            sx={{
                                display: { xs: 'none', md: 'flex' },
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                                px: 2,
                            }}
                        >
                            <Typography
                                variant="h3"
                                mb={2}
                                sx={{ fontWeight: 800, color: 'primary.main', lineHeight: 1.2 }}
                            >
                                {t('auth.forgotPassword')}
                            </Typography>
                            <Typography variant="body1" color="text.secondary" mb={4} sx={{ maxWidth: 380 }}>
                                {t('auth.forgotPasswordSubtitle')}
                            </Typography>
                            <Box
                                component="img"
                                src={iconLogin}
                                alt="Forgot Password"
                                sx={{
                                    maxWidth: '85%',
                                    height: 'auto',
                                    filter: 'drop-shadow(0px 20px 40px rgba(0,0,0,0.12))',
                                    animation: 'float 6s ease-in-out infinite',
                                    '@keyframes float': {
                                        '0%,100%': { transform: 'translateY(0px)' },
                                        '50%': { transform: 'translateY(-20px)' },
                                    }
                                }}
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={7}>
                        <Box sx={{ display: { xs: 'block', md: 'none' }, textAlign: 'center', mb: 3 }}>
                            <Typography variant="h4" fontWeight={800} color="primary.main" gutterBottom>
                                {t('auth.forgotPassword')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                                {t('auth.forgotPasswordSubtitle')}
                            </Typography>
                        </Box>
                        <FormForgotPassword />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default ForgotPassword
